'use client';
import { IconVolume } from 'components/ui/icons/player';
import styles from './change-value.module.scss';
import { useState } from 'react';
import { useAudeoVolume } from 'hooks';

export const ChangeValue = () => {
  const [isOpen, setIsOpen] = useState(false);

  /* Устанавливает и дает доступ к значению звука */
  const { volume, setVolume } = useAudeoVolume();

  /* Открытие/закрытие настройки звука */
  const onOpen = () => setIsOpen(!isOpen);

  /* Уводишь мышь пропадает настройка звука */
  const onMouseClose = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <article className={styles.wrap}>
      <button onClick={onOpen} className={styles.wrap__btn}>
        <IconVolume />
      </button>
      {isOpen && (
        <div className={styles.value} onMouseLeave={onMouseClose}>
          <label className={styles.value__label}>
            <input
              className={styles.value__input}
              min={0}
              max={1}
              step={0.01}
              onChange={({ target }) => setVolume(Number(target.value))}
              value={volume}
              type={'range'}
            /> {/* ползунок настройки громкости */}
          </label>
        </div>
      )}
    </article>
  );
};
